/** @typedef {import("../../../api/types").OrderNeighbors} OrderNeighbors */
import React from "react";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";
import {ChevronLeftIcon, ChevronRightIcon} from "../../../shared/components/icons";

/**
 * "Anterior" and "Próxima": quiet links to the order just before and just
 * after this one, by order number (the number is in the tooltip). They are
 * disabled at either end and while the neighbors are being found.
 *
 * @param {{neighbors: OrderNeighbors|null}} props `neighbors` is null while loading (or if it failed)
 */
const OrderNavigation = ({neighbors}) => (
    <nav className="d-flex align-items-center flex-shrink-0" aria-label="Navegar entre as ordens">
        <Step direction="previous" neighbors={neighbors} />
        <Step direction="next" neighbors={neighbors} />
    </nav>
);

const TEXT = {
    previous: {word: "Anterior", go: "Ordem anterior", none: "Não há ordem anterior"},
    next: {word: "Próxima", go: "Próxima ordem", none: "Não há próxima ordem"},
};

/** @param {{direction: "previous"|"next", neighbors: OrderNeighbors|null}} props */
const Step = ({direction, neighbors}) => {
    const {word, go, none} = TEXT[direction];
    const target = neighbors?.[direction] ?? null;
    const content =
        direction === "previous" ? (
            <>
                <ChevronLeftIcon />
                <span>{word}</span>
            </>
        ) : (
            <>
                <span>{word}</span>
                <ChevronRightIcon />
            </>
        );
    const className = "d-inline-flex align-items-center gap-1 text-decoration-none";

    if (!target) {
        return (
            // while looking, don't claim there is nothing there
            <Button
                color="link"
                size="sm"
                className={className}
                disabled
                title={neighbors ? none : undefined}
                aria-label={neighbors ? none : `${go} (procurando…)`}
            >
                {content}
            </Button>
        );
    }
    return (
        <Button
            color="link"
            size="sm"
            className={className}
            tag={Link}
            to={`/orders/${target.id}`}
            title={`${go}: nº ${target.number}`}
            aria-label={`${go}, nº ${target.number}`}
        >
            {content}
        </Button>
    );
};

export default OrderNavigation;
